import React from "react";
import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import ForumRoundedIcon from "@mui/icons-material/ForumRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import PersonSearchRoundedIcon from "@mui/icons-material/PersonSearchRounded";
import { trustBudTokens } from "../../../theme/tokens";

export default function NetworkHealthCard({
  nudge,
  onPrimaryAction,
  onSecondaryAction,
  onDismiss,
}) {
  if (!nudge) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 2,
        p: 2.2,
        borderRadius: "8px",
        border: "1px solid rgba(215, 226, 238, 0.98)",
        background:
          "linear-gradient(180deg, rgba(238, 245, 255, 0.98) 0%, rgba(248, 251, 255, 1) 100%)",
        boxShadow: "0 14px 32px rgba(15, 23, 42, 0.05)",
      }}
    >
      <Box
        sx={{
          width: 46,
          height: 46,
          borderRadius: "8px",
          backgroundColor: "rgba(23, 52, 93, 0.08)",
          color: trustBudTokens.colors.brand.navy700,
          display: "grid",
          placeItems: "center",
          flexShrink: 0,
        }}
      >
        <ForumRoundedIcon sx={{ fontSize: 22 }} />
      </Box>

      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Stack direction="row" spacing={1.5} alignItems="flex-start" justifyContent="space-between">
          <Box sx={{ minWidth: 0 }}>
            <Typography
              sx={{
                fontSize: 18,
                lineHeight: 1.25,
                fontWeight: 800,
                color: trustBudTokens.colors.text.primary,
              }}
            >
              {nudge.title}
            </Typography>
            <Typography
              sx={{
                mt: 0.55,
                fontSize: 14,
                lineHeight: 1.55,
                color: trustBudTokens.colors.text.secondary,
                maxWidth: 620,
              }}
            >
              {nudge.body}
            </Typography>
          </Box>

          {nudge.dismissible ? (
            <IconButton
              size="small"
              onClick={onDismiss}
              aria-label="Dismiss network health nudge"
              sx={{ color: trustBudTokens.colors.text.muted, mt: -0.4, mr: -0.5 }}
            >
              <CloseRoundedIcon fontSize="small" />
            </IconButton>
          ) : null}
        </Stack>

        <Stack direction="row" spacing={1.1} sx={{ mt: 1.5, flexWrap: "wrap" }}>
          <Button
            variant="contained"
            startIcon={<ForumRoundedIcon />}
            onClick={onPrimaryAction}
            sx={{
              borderRadius: "8px",
              px: 2,
              py: 1.1,
              textTransform: "none",
              fontWeight: 700,
              backgroundColor: trustBudTokens.colors.brand.navy700,
              "&:hover": {
                backgroundColor: trustBudTokens.colors.brand.navy800,
              },
            }}
          >
            {nudge.primary_cta_label || "Open Activity"}
          </Button>
          <Button
            variant="text"
            startIcon={<PersonSearchRoundedIcon />}
            onClick={onSecondaryAction}
            sx={{
              borderRadius: "8px",
              px: 1.4,
              py: 1.1,
              textTransform: "none",
              fontWeight: 700,
              color: trustBudTokens.colors.brand.navy700,
            }}
          >
            {nudge.secondary_cta_label || "Find people"}
          </Button>
        </Stack>
      </Box>
    </Box>
  );
}
